import { defaultCity } from "@constants/cities";
import Cookies from "js-cookie";
import { addCookieToWebView } from "@hooks/useWebviewCallback";
import { inApp } from "@utils/platformDetection.client";
import {
  CITY_SLUG_COOKIE_NAME,
  SELECTED_CITY_COOKIE_NAME,
  USER_SELECTED_CITY_COOKIE_NAME,
} from "@constants/cityCookies";

type CityCookie = {
  id: number;
  name: string;
  slug: string;
};

const DEFAULT_CITY: CityCookie = {
  id: defaultCity.id,
  name: defaultCity.name,
  slug: defaultCity.city_slug,
};
const CITY_COOKIE_OPTIONS = {
  expires: 365,
  sameSite: "lax" as const,
};

export const getSelectedCityClient = (): CityCookie => {
  const raw = Cookies.get(SELECTED_CITY_COOKIE_NAME);

  if (raw) {
    try {
      const parsed = JSON.parse(raw);
      if (parsed?.id && parsed?.name && parsed?.slug) {
        return parsed as CityCookie;
      }
    } catch (err) {
      console.warn("selected_city cookie is corrupted. Resetting to default.");
    }
  }

  // If not found or malformed, set and return default city
  setSelectedCityClient(DEFAULT_CITY);
  return DEFAULT_CITY;
};

export const setSelectedCityClient = (city: CityCookie): void => {
  const selectedCityValue = JSON.stringify(city);
  Cookies.set(SELECTED_CITY_COOKIE_NAME, selectedCityValue, CITY_COOKIE_OPTIONS);

  Cookies.set(CITY_SLUG_COOKIE_NAME, city.slug, CITY_COOKIE_OPTIONS);

  if (inApp()) {
    addCookieToWebView(SELECTED_CITY_COOKIE_NAME, selectedCityValue);
    addCookieToWebView(CITY_SLUG_COOKIE_NAME, city.slug);
  }
};

export const markCityAsUserSelectedClient = (): void => {
  Cookies.set(USER_SELECTED_CITY_COOKIE_NAME, "true", CITY_COOKIE_OPTIONS);

  if (inApp()) {
    addCookieToWebView(USER_SELECTED_CITY_COOKIE_NAME, "true");
  }
};
